"use strict";
/**
 * @module "ethpm/registries/web3"
 */
Object.defineProperty(exports, "__esModule", { value: true });
class Paged {
    constructor(pageSize) {
        this.pageSize = pageSize.clone();
        this.pages = {};
    }
    pointerToPage(pointer) {
        return pointer.div(this.pageSize);
    }
    setPage(page, value) {
        this.pages[page.toNumber()] = value;
    }
    setPages(pageIds) {
        this.pages = pageIds;
    }
    hasPage(pointer) {
        return typeof this.pages[this.pointerToPage(pointer).toNumber()] !== 'undefined';
    }
    getDatum(pointer) {
        if (this.hasPage(pointer)) {
            const page = this.pages[this.pointerToPage(pointer).toNumber()];
            const index = pointer.mod(this.pageSize).toNumber();
            return page[index];
        }
        return null;
    }
}
exports.default = Paged;
